import * as React from 'react';
import ISe360User from './ISe360User';
import { Translate } from '../../shared/LanguageService';
import { Button, ButtonToolbar } from 'react-bootstrap';
import DeleteButton from '../../components/common/DeleteButton';
import * as Features from '../../shared/Features';
import TelephoneLink from '../../components/common/TelephoneLink';
import EmailLink from '../../components/common/EmailLink';

interface ISe360UserListRowProps {
    loggedInUser: any;
    user: ISe360User;
    key: number;
    delete: (id: number) => void;
    beginEdit: (id: number) => void;
    restoreUser: (id: number) => void;
    handleSpecialAuthorizations: (id: number) => void;
    showLogs: (id: number) => void;
}

const Se360UserListRow = (props: ISe360UserListRowProps) => {
    return (
        <tr>
            <td className={props.user.isRemoved ? 'disabled' : ''}>{props.user.name}</td>
            <td className={props.user.isRemoved ? 'disabled' : ''}>
                <EmailLink>{props.user.email}</EmailLink>
            </td>
            <td className={props.user.isRemoved ? 'disabled' : ''}>
                <TelephoneLink>{props.user.phoneNumber}</TelephoneLink>
            </td>
            <td className={props.user.isRemoved ? 'disabled' : ''}>
                {Translate(props.user.roleTranslationKey)}
            </td>
            <td className={props.user.isRemoved ? 'disabled' : ''}>
                {Translate(props.user.country)}
            </td>
            <td className={'tools' + (props.user.isRemoved ? ' disabled' : '')}>
                <ButtonToolbar className="pull-right btn-group-sm flex">
                    {props.user.isRemoved === false &&
                        Features.hasFeature(Features.DeleteSe360Users, props.loggedInUser) && (
                            <DeleteButton
                                disabled={props.user.id === props.loggedInUser.details.id}
                                onDelete={() => props.delete(props.user.id)}
                                text={Translate('se360users/list/row/delete/remove-this-user')}
                            >
                                <i className="material-icons">delete</i>{' '}
                                {Translate('se360users/list/row/button-label/delete')}
                            </DeleteButton>
                        )}
                    {props.user.isRemoved === true &&
                        Features.hasFeature(Features.RestoreSe360Users, props.loggedInUser) && (
                            <Button
                                bsStyle="default"
                                onClick={() => props.restoreUser(props.user.id)}
                            >
                                <i className="material-icons">restore</i>{' '}
                                {Translate('se360users/list/row/button-label/restore')}
                            </Button>
                        )}
                    {Features.hasFeature(Features.UpdateSe360Users, props.loggedInUser) && (
                        <Button onClick={() => props.beginEdit(props.user.id)} bsStyle="primary">
                            <i className="material-icons">edit</i>{' '}
                            {Translate('se360users/list/row/button-label/edit')}
                        </Button>
                    )}
                    <Button onClick={() => props.showLogs(props.user.id)} bsStyle="default">
                        <i className="material-icons">list</i>{' '}
                        {Translate('se360users/list/row/button-label/logs')}
                    </Button>
                    {Features.hasFeature(
                        Features.HandleSpecialAuthorizations,
                        props.loggedInUser
                    ) && (
                        <Button
                            onClick={() => props.handleSpecialAuthorizations(props.user.id)}
                            bsStyle="default"
                        >
                            <i className="material-icons">security</i>{' '}
                            {Translate('se360users/list/row/button-label/special-authorizations')}
                        </Button>
                    )}
                </ButtonToolbar>
            </td>
        </tr>
    );
};

export default Se360UserListRow;
